module.exports = __webpack_public_path__ + "media/images/flags/16/Curacao-2c2fd826d10385f8c86363439818ace8.png";